import React from 'react'
import { Sparkles } from 'lucide-react'

interface GuideWidgetProps {
  title: string
  children: React.ReactNode
  footnote?: string
}

export default function GuideWidget({ title, children, footnote }: GuideWidgetProps) {
  return (
    <div className="rounded-xl border border-primary/20 bg-gradient-to-br from-slate-50/80 via-white to-teal-50/30 shadow-sm overflow-hidden">
      <div className="flex items-center gap-2 border-b border-primary/10 bg-primary/[0.03] px-5 py-2.5">
        <Sparkles className="h-3.5 w-3.5 text-primary" />
        <span className="text-xs font-semibold text-primary tracking-wide uppercase">Try it</span>
        <span className="text-xs text-muted-foreground">{title}</span>
      </div>
      <div className="p-5">
        {children}
      </div>
      {footnote && (
        <div className="border-t border-border/30 bg-muted/20 px-5 py-2">
          <p className="text-[11px] text-muted-foreground">{footnote}</p>
        </div>
      )}
    </div>
  )
}
